var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAppstore = function SvgIconAppstore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.368 12.609c-.022-2.419 2.03-3.595 2.125-3.65-1.163-1.653-2.965-1.879-3.599-1.897-1.513-.155-2.982.883-3.753.883-.786 0-1.974-.868-3.254-.842-1.646.025-3.187.954-4.032 2.398-1.744 2.943-.443 7.269 1.227 9.648.836 1.165 1.813 2.466 3.091 2.42 1.25-.05 1.718-.777 3.227-.777 1.495 0 1.934.778 3.237.748 1.342-.02 2.187-1.17 2.994-2.346.966-1.335 1.354-2.65 1.369-2.718-.032-.01-2.607-.969-2.632-3.867ZM14.905 5.497c.673-.82 1.133-1.936 1.005-3.068-.973.042-2.19.657-2.892 1.459-.62.707-1.174 1.865-1.03 2.954 1.093.08 2.216-.538 2.917-1.345Z",
    fill: "#fff"
  })));
};
export default SvgIconAppstore;